import { createSlice } from '@reduxjs/toolkit';

const slice = createSlice({
    name: 'createLeadDialog',
    initialState: { open: false, dentallyBookingOpen: false },
    reducers: {
        openCreateLeadDialog(state) {
            state.open = true;
        },
        closeCreateLeadDialog(state) {
            state.open = false;
        },
        openDentallyBookingDialog(state) {
            state.dentallyBookingOpen = true;
        },
        closeDentallyBookingDialog(state) {
            state.dentallyBookingOpen = false;
        },
    },
});

export const { openCreateLeadDialog, closeCreateLeadDialog, openDentallyBookingDialog, closeDentallyBookingDialog } = slice.actions;
export default slice.reducer;
